// extracted by mini-css-extract-plugin
module.exports = {"certificate-modal":"SurveyCertificateWrapper_certificate-modal__1855G","certificate-modal__header":"SurveyCertificateWrapper_certificate-modal__header__53MA6"};